import * as React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import { STORE_AUTH, STORE_REJECTIONS } from '../constants';
import { AuthStore } from '../stores';

interface IHeaderProps {
    logout: () => void;
}

@inject(STORE_AUTH, STORE_REJECTIONS)
@observer
export class Header extends React.Component<IHeaderProps, any> {

    logout = () => {
        document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        this.props.logout();
    }

    public render() {
        const authStore = (this.props as any)[STORE_AUTH] as AuthStore;


        return <Navbar bg="dark" variant="dark" fixed="top">

            <Navbar.Brand href="/" key={"0-0"}>
                {"Подбор БО"}
            </Navbar.Brand>

            {
                authStore.isAuthenticated ? [
                    <Nav className="mr-auto" key={"0-1"}>
                        {authStore.isCallCentre || authStore.isFranchise ?
                            <LinkContainer to="/sales/customerorders" key={"1-1"}>
                                <Nav.Link href="/sales/customerorders">Продажи</Nav.Link>
                            </LinkContainer> : []
                        }
                        {authStore.isInRole("KassesManager") ?
                            <LinkContainer to="/kassesmanagement/kasses" key={"4-1"}>
                                <Nav.Link href="/kassesmanagement/kasses">Кассы</Nav.Link>
                            </LinkContainer> : []
                        }
                        {authStore.isFranchise || authStore.isDeliveryPoint || authStore.isInRole("FullAccessManager") ?
                            <LinkContainer to="/deliverypoint/demands" key={"2-1"}>
                                <Nav.Link href="/deliverypoint/demands">Точка выдачи</Nav.Link>
                            </LinkContainer> : []
                        }
                        {authStore.roles.indexOf("Reports") > -1 ? [
                            <LinkContainer to="/reports/report1" key={"3-1"}>
                                <Nav.Link href="/reports/report1">Отчеты</Nav.Link>
                            </LinkContainer>
                        ] : []}
                        {authStore.roles.indexOf("UserManagement") > -1 ? [
                            <LinkContainer to="/users/users" key={"3-1"}>
                                <Nav.Link href="/users/users">Пользователи</Nav.Link>
                            </LinkContainer>
                        ] : []}
                    </Nav>, authStore.isFranchise || authStore.isDeliveryPoint ? <Navbar.Brand key={"3-4"}><small style={{ color: "rgba(255, 255, 255, 0.5)" }}>{authStore.deliveryPointName}</small></Navbar.Brand> : [],
                    authStore.roles.indexOf("AsToAbtekaManager") > -1 ? <Nav key={"0-3"}>
                        <LinkContainer to="/abtekatoasbinding/abtekatoasbinding" key={"3-1"}>
                            <Nav.Link href="/abtekatoasbinding/abtekatoasbinding">Аккаунт автосоюза</Nav.Link>
                        </LinkContainer>
                    </Nav> : [],
                    
                    <Nav key={"0-2"}>
                        <Nav.Link onClick={this.logout}>
                            <FontAwesomeIcon icon="sign-out-alt" /> {"Выйти"}
                        </Nav.Link>
                    </Nav>
                ]
                    :
                    [
                        <Nav className="mr-auto" key={"3-5"}></Nav>,
                        <Nav key={"3-6"}>
                            <Nav.Link href="/login">
                                <FontAwesomeIcon icon="sign-out-alt" /> {"Войти"}
                            </Nav.Link>
                        </Nav>
                    ]
            }

        </Navbar >;
    }
}
